import { InfoLanguage } from "@bandido/shared/enums";
import { flagSpain, flagUnitedStates, flagBrazil } from "@frontend/assets";

interface LanguageConfig {
  code: InfoLanguage;
  flag: string;
  name: string;
}
export const languages: LanguageConfig[] = [
  { code: InfoLanguage.Spanish, flag: flagSpain, name: 'Español' },
  { code: InfoLanguage.English, flag: flagUnitedStates, name: 'English' },
  { code: InfoLanguage.Portuguese, flag: flagBrazil, name: 'Português' },
];
